import { render, staticRenderFns } from "./WorkspaceGeneSetProvenanceViz.vue?vue&type=template&id=67407f2b&scoped=true"
import script from "./WorkspaceGeneSetProvenanceViz.vue?vue&type=script&lang=js"
export * from "./WorkspaceGeneSetProvenanceViz.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceGeneSetProvenanceViz.vue?vue&type=style&index=0&id=67407f2b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67407f2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67407f2b')) {
      api.createRecord('67407f2b', component.options)
    } else {
      api.reload('67407f2b', component.options)
    }
    module.hot.accept("./WorkspaceGeneSetProvenanceViz.vue?vue&type=template&id=67407f2b&scoped=true", function () {
      api.rerender('67407f2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceGeneSetProvenanceViz.vue"
export default component.exports